module.exports = __webpack_public_path__ + "img/biaoqian_shehuijiuzhu.a64fdd9d.png";